import React, { useEffect, useRef } from "react";
import { createSpring } from "../spring";

function canTrack() {
  return window.matchMedia("(hover: hover) and (pointer: fine)").matches
    && !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

function PointerField() {
  const glowRef = useRef(null);

  useEffect(() => {
    const glow = glowRef.current;
    if (!glow) return undefined;

    let target = { x: 0, y: 0 };
    const spring = createSpring(
      () => target,
      (x, y) => {
        glow.style.transform = `translate3d(${x}px, ${y}px, 0)`;
      },
    );

    const onMove = (event) => {
      if (!canTrack()) {
        glow.classList.remove("is-live");
        return;
      }
      target = { x: event.clientX, y: event.clientY };
      glow.classList.add("is-live");
      spring.kick();
    };

    window.addEventListener("pointermove", onMove);
    return () => {
      spring.stop();
      window.removeEventListener("pointermove", onMove);
    };
  }, []);

  return <div ref={glowRef} className="pointer-glow" aria-hidden="true" />;
}

export default PointerField;
